'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
const encodeDiscount = discount => {
  let adjustedDiscount = discount;
  if (discount > 100) {
    adjustedDiscount = adjustedDiscount.slice(0, -1);
  }
  const decimal = adjustedDiscount / 100;
  const adjustedDecimal = decimal.toFixed(3);
  return adjustedDecimal;
};
const decodeDiscount = discount => {
  let adjustedPercentage = discount * 100;
  if (adjustedPercentage % 1 !== 0) {
    adjustedPercentage = adjustedPercentage.toFixed(1);
  } else {
    adjustedPercentage = adjustedPercentage.toFixed();
  }
  return adjustedPercentage ? `${Number(adjustedPercentage)}` : '0';
};
const getTotalDiscount = _ref => {
  let {
    spaceDiscount = 0,
    bookingDiscount = 0,
    customerDiscount = 0
  } = _ref;
  return (1 - (1 - spaceDiscount) * (1 - bookingDiscount) * (1 - customerDiscount)).toFixed(3);
};
const getDiscountedHourlyRate = _ref2 => {
  let {
    hourlyRate,
    additionalMinimumSpent,
    ...discounts
  } = _ref2;
  return ((Number(hourlyRate) + Number(additionalMinimumSpent || 0)) * (1 - getTotalDiscount({
    ...discounts
  }))).toFixed(2);
};
const getDiscountBreakdown = _ref3 => {
  let {
    hourlyRate,
    spaceDiscount = 0,
    bookingDiscount = 0,
    customerDiscount = 0
  } = _ref3;
  let breakdown = `Hourly rate (£${hourlyRate})`;
  if (Number(spaceDiscount)) breakdown += ` x Space discount (${decodeDiscount(spaceDiscount)}%)`;
  if (Number(bookingDiscount)) breakdown += ` x Booking discount (${decodeDiscount(bookingDiscount)}%)`;
  if (Number(customerDiscount)) breakdown += ` x Customer discount (${decodeDiscount(customerDiscount)}%)`;
  return breakdown;
};
exports.decodeDiscount = decodeDiscount;
exports.encodeDiscount = encodeDiscount;
exports.getDiscountBreakdown = getDiscountBreakdown;
exports.getDiscountedHourlyRate = getDiscountedHourlyRate;
exports.getTotalDiscount = getTotalDiscount;